import { Questions, Solutions } from './Data';
import { Store, Weights, Flow } from './Store';

export function setupLocalStorage() {

  if (!localStorage.getItem('apcyoa')) {
    let lsobj = [];
    localStorage.setItem('apcyoa', JSON.stringify(lsobj));
  }

}

export function appendToLocalStorage(obj) {

  let ls = JSON.parse(localStorage.getItem('apcyoa'));

  ls.push(obj);

  localStorage.setItem('apcyoa', JSON.stringify(ls));

  //let ls2 = JSON.parse(localStorage.getItem('apcyoa'));
  //console.log(ls2);

}

export function resetStore() {
  // reset flows as well
  Flow.completed.length = 0;
  Flow.desired.length = 0;

  Store.length = 0;
  for (let s = 0; s < Questions.length; s++) {
    
    /*if (process.env.NODE_ENV === 'development') {
      let storeObj = {
        'answer' : [1]
      };
      Store.push(storeObj);
    } else {*/
      let storeObj = {
        'answer' : []
      };
      Store.push(storeObj);
    //}
    
  }
}

export function setFlowDesired(currentQuestionNo, returned) {
  Flow.desired.length = 0;
  // loop through questions and get flow desired
  for (let q = 0; q < Store.length; q++) {
    // loop answers
    for (let a = 0; a < Store[q].answer.length; a++) {
      Flow.desired.push(Questions[q].next[Store[q].answer[a]]);
    }
  }

  // unique array of desired
  Flow.desired = [...new Set(Flow.desired)];
  // order the array lowest question to highest
  Flow.desired.sort(function(a, b) {
    return a - b;
  });

  // remove all greater than currentQuestionNo if returned
  if (returned) {
    let index = Flow.desired.findIndex(function(number) {
      return number > currentQuestionNo;
    });
    if (index > 0) {
      Flow.desired.length = index + 1;
    }
  }
  console.log(currentQuestionNo);
  console.log(Flow.desired);
}

export function resetWeights() {
  Weights.length = 0;

  // set up categories
  let q = 0;
  Questions[0].solutions.forEach((key) => {
    // get solution name
    let SolutionName = Object.keys(Questions[0].solutions[q])[0];

    let SolutionObj = Solutions.find((element) => {
      return element.solution === SolutionName;
    });

    let set = true;

    for (let i = 0; i < Weights.length; i++) {
      if (Weights[i].category === SolutionObj.category) {
        set = false;
      }
    }

    if (set) {
      let categoryObj = {
        'category' : SolutionObj.category,
        'value' : 0,
        'solutions' : []
      };
      Weights.push(categoryObj);
    }

    q++;

  });

  //***** Need to loop through seperate solutions object?
  let z = 0;
  Questions[0].solutions.forEach((key) => {
    // get solution name
    let SolutionName = Object.keys(Questions[0].solutions[z])[0];

    let SolutionObj = Solutions.find((element) => {
      return element.solution === SolutionName;
    });

    let SolutionCategory = SolutionObj.category;
    let SolutionIcon = SolutionObj.icon;
    let SolutionInfo = SolutionObj.information;

    Weights
      .filter(element => element.category === SolutionCategory)
      .map((element, i) => {
        let solutionObj = {
          'solution' : SolutionName,
          'weight' : 0,
          'icon' : SolutionIcon,
          'information' : SolutionInfo
        };
        element.solutions.push(solutionObj);
        return true;
    });

    z++;
  });
}

export function calculateWeights() {
  // calculate weights as fer answers
  let i = 0;
  Store.forEach((element) => {

    // array of answers for that question
    let answerKeys = element.answer;
    let currentQuestion = Questions[i];
    let currentQuestionSolutions = Questions[i].solutions;
    
    let z = 0;
    currentQuestionSolutions.forEach((currentQuestionSolution) => {
      // get solution name
      let SolutionName = Object.keys(currentQuestion.solutions[z])[0];

      let SolutionObj = Solutions.find((element) => {
        return element.solution === SolutionName;
      });

      let SolutionCategory = SolutionObj.category;
      
      // loop through answers and get weights for the solutions
      for (let s = 0; s < answerKeys.length; s++) {
        // weight for that solution
        Weights
          .filter(element => element.category === SolutionCategory)
          .map((element, i) => {

            let CategorySolutions = element.solutions;

            CategorySolutions.forEach((key) => {
              // find that solution
              if (key.solution === SolutionName) {
                key.weight = key.weight + parseInt(currentQuestionSolutions[z][SolutionName][answerKeys[s]],10);
              }
            });

            return true;
          
        });
      }
      z++;
      
    });
    i++;

  });

  Weights.forEach((key) => {

    let CategorySolutions = key.solutions;
    let CatWeight = 0;

    CategorySolutions.forEach((key) => {
      if (key.weight > 0) {
        CatWeight = CatWeight + 1;
      }
    });

    key.value = CatWeight;

  });

}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}


// WEBPACK FOOTER //
// ./src/Functions.js